<template>
  <div class="all">
    <my-title :msg="title"></my-title>
    <div class="MyPoints">
      <div class="MyPoints_title">
        <el-button type="success" style="border: none;" @click="getADD">新增地址</el-button>
      </div>
    </div>
    <div class="MyPoints_form_ul">
      <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;">
        <el-col :span="4">
          <div class="grid-content">收货人</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">手机号</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">省市区</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">详细地址</div>
        </el-col>
        <!--              <el-col :span="4"><div class="grid-content">获取积分数</div></el-col>-->
        <el-col :span="4">
          <div class="grid-content">时间</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">操作</div>
        </el-col>
      </el-row>
      <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;" v-for="(item,index) in DataList"
              :key="index">
        <el-col :span="4">
          <div class="grid-content">{{item.name}}</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">{{item.phone}}</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">{{item.pro_name}}{{item.city_name}}{{item.area_name}}</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">{{item.add_ress}}</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content" v-if="item.add_time">{{item.add_time | filterDate('yyyy/MM/dd')}}</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content" v-if="item.add_time == null"> 暂无</div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-button type="success" style="border: none;" @click="getSave(item.id)">修改</el-button>
            <el-button type="danger" style="border: none;" @click="getDel(item.id)">删除</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-dialog :title="form.id?'修改收货地址':'新增收货地址'" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="收货人姓名" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收货人手机" :label-width="formLabelWidth">
            <el-input v-model="form.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收货地址" :label-width="formLabelWidth">
            <el-select v-model="form.pro_id" placeholder="请选择省" @change="getCityY(form.pro_id)">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in CityDataY" :key="index"></el-option>
            </el-select>
            <el-select v-model="form.city_id" placeholder="请选择市" @change="getCityS(form.city_id)">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in CityDataS" :key="index"></el-option>
            </el-select>
            <el-select v-model="form.area_id" placeholder="请选择区/县">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in CityDataQ" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="form.add_ress">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="getAddRe">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {getsaveress, getaddress, getCity, getfindress, getfsaveress,getdelete} from '../api/Mycen'

  export default {
    name: "MyPoints",
    data() {
      return {
        title: "我的积分",
        type: 1,
        DataList: {},
        DataListLint: [],
        //弹框
        dialogTableVisible: false,
        dialogFormVisible: false,
        form: {
          name: '',
          id: '',
          phone: '',
          pro_id: '',
          city_id: '',
          area_id: '',
          add_ress: '',
        },
        formLabelWidth: '120px',
        //城市
        CityDataY: [],
        CityDataS: [],
        CityDataQ: [],
      }
    },
    mounted() {
      this.init()
    },
    /*
    *
    *      this.$alert('确定删除吗', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            getdelete({id: id}).then(res => {
              this.init()
            })
          }
        });
    * */
    methods: {
      //删除
      getDel(id) {
        this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getdelete({id: id}).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.init()
          })
        }).catch(() => {
          /*this.$message({
            type: 'info',
            message: '已取消删除'
          });*/
        });
      },
      getADD() {
        this.form.id = ''
        this.form.name = ''
        this.form.phone = ''
        this.form.pro_id = ''
        this.form.city_id = ''
        this.form.area_id = ''
        this.form.add_ress = ''
        this.dialogFormVisible = true
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
      },
      getCityY(iod) {
        this.form.city_id = ''
        this.form.area_id = ''
        getCity({parentid: iod}).then(res => {
          this.CityDataS = res.result
        })
      },
      getCityS(iod) {
        getCity({parentid: iod}).then(res => {
          this.CityDataQ = res.result
        })
      },
      init() {
        getsaveress().then(res => {
          this.DataList = res.result
        })
        getCity().then(res => {
          this.CityDataY = res.result
        })
      },
      getAddRe() {
        if (this.form.id) {
          getfsaveress(this.form).then(res => {
            this.dialogFormVisible = false
            this.init()
          })
        } else {
          getaddress(this.form).then(res => {
            this.dialogFormVisible = false
            this.init()
          })
        }
      },
      //修改前查询
      getSave(id) {
        getfindress({id: id}).then(res => {
          this.dialogFormVisible = true
          this.form = res.result
          this.form.pro_id = String(res.result.pro_id)
          this.form.city_id = String(res.result.city_id)
          this.form.area_id = String(res.result.area_id)
          getCity({parentid: this.form.pro_id}).then(res => {
            this.CityDataS = res.result
            getCity({parentid: this.form.city_id}).then(res => {
              this.CityDataQ = res.result
            })
          })
        })
      },
      getType(e) {
        if (e == 1) {
          this.type = 2
          this.init()
        } else {
          this.type = 1
          this.init()
        }
      },
    }
  }
</script>

<style scoped lang="less">
  @import "css/MyAds";
</style>



// WEBPACK FOOTER //
// src/components/MyAds.vue